<template>
  <nav
    class="navbar is-transparent is-mobile pt-6"
    role="navigation"
    aria-label="main navigation"
    style="border-bottom: 1px solid gray"
  >
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item is-hoverable">
        <img
          alt="AlfaPack_Logo_Vectores_alfapack_solutions_horizontal"
          src="../assets/AlfaPack_Logo_Vectores_alfapack_solutions_horizontal.png"
        />
      </router-link>

      <a
        @click="showMenu"
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="alfaNav"
        style="margin-top: auto; margin-bottom: auto"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div v-if="width < 768" id="alfaNavMobile" class="navbar-menu">
      <div class="navbar-start">
        <router-link to="/nosotros" class="navbar-item nav-text is-hoverable"
          >NOSOTROS</router-link
        >
        <div class="navbar-item has-dropdown is-hoverable">
          <a
            class="navbar-link is-arrowless nav-text"
            @click="toggleEquiposNav"
          >
            EQUIPOS
          </a>
          <div v-if="showEquiposNav" class="navbar-dropdown">
            <div
              v-for="(clasificacion, index) in CLASIFICACION_EQUIPOS"
              v-bind:key="index"
              class="navbar-item level-item is-uppercase nav-equipo-text"
            >
              <router-link to="/equipo">{{ clasificacion.label }}</router-link>
            </div>
          </div>
        </div>
        <router-link
          to="/representadas"
          class="navbar-item nav-text is-hoverable"
          >REPRESENTADAS</router-link
        >
        <router-link to="/" class="navbar-item nav-text is-hoverable"
          >NOTICIAS</router-link
        >
        <router-link
          to="/cotizaciones"
          class="navbar-item nav-text is-hoverable"
          >COTIZACIONES</router-link
        >
      </div>
    </div>
    <div v-else id="alfaNav" class="navbar-menu">
      <div class="navbar-start">
        <router-link to="/nosotros" class="navbar-item nav-text is-hoverable"
          >NOSOTROS</router-link
        >
        <div class="navbar-item has-dropdown is-hoverable">
          <a
            class="navbar-link is-arrowless nav-text"
            @click="toggleEquiposNav"
          >
            EQUIPOS
          </a>
        </div>
        <router-link
          to="/representadas"
          class="navbar-item nav-text is-hoverable"
          >REPRESENTADAS</router-link
        >
        <router-link to="/" class="navbar-item nav-text is-hoverable"
          >NOTICIAS</router-link
        >
        <router-link
          to="/cotizaciones"
          class="navbar-item nav-text is-hoverable"
          >COTIZACIONES</router-link
        >
      </div>
    </div>
  </nav>
  <nav
    v-if="showEquiposNav && width >= 768"
    class="navbar is-transparent level is-mobile"
    style="width: 100%"
  >
    <div
      v-for="n in 6"
      v-bind:key="n"
      class="navbar-item level-item has-text-centered is-uppercase nav-equipo-text"
    >
      <div>
        <router-link to="/equipo">
          <figure class="image heading">
            <img
              :src="CLASIFICACION_EQUIPOS[n - 1].logo"
              :alt="CLASIFICACION_EQUIPOS[n - 1].alt"
              style="max-height: 35px; width: auto"
            />
          </figure>
          <p>
            {{ CLASIFICACION_EQUIPOS[n - 1].label }}
          </p>
        </router-link>
      </div>
    </div>
  </nav>
  <nav
    v-if="showEquiposNav && width >= 768"
    class="navbar is-transparent level is-mobile"
    style="width: 100%"
  >
    <div class="navbar-start">
      <div
        v-for="n in 2"
        v-bind:key="n"
        class="navbar-item level-item has-text-centered is-uppercase nav-equipo-text"
      >
        <div>
          <router-link to="/equipo">
            <figure class="image heading">
              <img
                :src="CLASIFICACION_EQUIPOS[n + 5].logo"
                :alt="CLASIFICACION_EQUIPOS[n + 5].alt"
                style="max-height: 35px; width: auto"
              />
            </figure>
            <p>
              {{ CLASIFICACION_EQUIPOS[n + 5].label }}
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </nav>
  <router-view />
</template>
<script setup lang="ts">
import { CLASIFICACION_EQUIPOS } from "@/use-equipos";
import { Ref, ref } from "vue";
import { useWindowSize } from "vue-window-size";

const { width } = useWindowSize();

const showEquiposNav: Ref<boolean> = ref(false);

function toggleEquiposNav() {
  showEquiposNav.value = !showEquiposNav.value;
}

function showMenu() {
  const mobileNav = document.getElementById("alfaNavMobile");
  let isDisplayed = mobileNav?.style.display;
  if (mobileNav && isDisplayed && isDisplayed == "block") {
    mobileNav.setAttribute("style", "display: none !important;");
  } else if (mobileNav && (!isDisplayed || isDisplayed == "none")) {
    mobileNav.setAttribute("style", "display: block !important;");
  }
}
</script>
